import React from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetGalleryCategoriesQuery,
  useDeleteGalleryCategoryMutation,
} from "./galleryCategoriesApiSlice";

const GalleryCategoryList = () => {
  const navigate = useNavigate();

  const {
    data: categories = [],
    isLoading,
    isError,
    error,
  } = useGetGalleryCategoriesQuery();
//console.log('category',categories.data.length)
  const [deleteCategory] = useDeleteGalleryCategoryMutation();

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await deleteCategory(id).unwrap();
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <div className="container mt-4">

      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Gallery Categories</h2>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/dashboard/gallery-categories/new")}
        >
          Add Category
        </button>
      </div>

      {/* Content */}
      <div className="card">
        <div className="card-body">

          {isLoading && <p>Loading...</p>}

          {isError && (
            <p className="text-danger">
              {error?.data?.message || "Something went wrong"}
            </p>
          )}

          {!isLoading && categories.length === 0 && (
            <p>No categories found.</p>
          )}

          {!isLoading && categories.data.length > 0 && (
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Status</th>
                    <th style={{ width: "150px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.data.map((cat) => (
                    <tr key={cat._id}>
                      <td>{cat.title}</td>
                      <td>
                        {cat.isActive ? (
                          <span className="badge bg-success">Active</span>
                        ) : (
                          <span className="badge bg-secondary">Inactive</span>
                        )}
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-warning me-2"
                          onClick={() =>
                            navigate(`/dashboard/gallery-categories/${cat._id}`)
                          }
                        >
                          Edit
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(cat._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default GalleryCategoryList;
